<div class="container mx-auto px-4 py-6">
    <div class="max-w-3xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
      <div class="px-4 py-6 bg-gray-50 sm:px-6">
        <div class="flex items-center justify-between gap-3">
          <div class="flex items-center gap-3 min-w-0">
            <button
              type="button"
              (click)="goBack()"
              class="inline-flex shrink-0 items-center justify-center rounded-lg border border-gray-300 bg-white p-2 text-gray-700 shadow-sm transition hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              aria-label="Back to home">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h2 class="text-xl font-medium text-gray-900 truncate">App Settings</h2>
          </div>
        </div>
      </div>
      <div class="px-4 py-4 sm:px-6">
        <div class="flex items-center justify-between">
          <div>
            <h3 class="text-lg font-medium text-gray-900">Notification Sound</h3>
            <p class="text-sm text-gray-500">Toggle the switch to enable or disable notification sound.</p>
          </div>
          <div class="flex items-center">
            <button
              type="button"
              (click)="toggleNotificationSound()"
              [ngClass]="{
                'bg-indigo-600': notificationSound, 
                'bg-gray-200': !notificationSound
              }"
              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
              role="switch"
              [attr.aria-checked]="notificationSound">
              <span class="sr-only">Use setting</span>
              <!-- Handle position -->
              <span
                aria-hidden="true"
                [ngClass]="{
                  'translate-x-5': notificationSound, 
                  'translate-x-0': !notificationSound
                }"
                class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out">
              </span>
            </button>
          </div>
        </div>
      </div>


      <div class="px-4 py-4 mt-3 sm:px-6" *ngIf="user?.roles.includes('gm') || user?.roles.includes('developer')">
        <div class="flex items-center justify-between">
          <div>
            <h3 class="text-lg font-medium text-gray-900">Activate Assigned To Feature</h3>
            <p class="text-sm text-gray-500">Toggle the switch to enable or disable feature <strong>Assigned To</strong>.</p>
            <p class="text-sm text-gray-500"> To activate, your team must have more than one Estimator or Parts Coordinator roles assigned.</p>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                <strong>Parts Coordinators:</strong> {{ partsCoordinatorCount }}
              </p>
              <p class="text-sm text-gray-500">
                <strong>Estimators:</strong> {{ estimatorCount }}
              </p>
            </div>
          </div>
          <div class="flex items-center">
            <button
              type="button"
              [disabled]="!assignedToRoleCnt.status"
              (click)="setAssignedToActiveForTenant(assignedToActive)"
              [ngClass]="{
                'bg-indigo-600': assignedToActive, 
                'bg-gray-200': !assignedToActive
              }"
              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
              role="switch"
              [attr.aria-checked]="assignedToActive">
              <span class="sr-only">Use setting</span>
              <!-- Handle position -->
              <span
                aria-hidden="true"
                [ngClass]="{
                  'translate-x-5': assignedToActive, 
                  'translate-x-0': !assignedToActive
                }"
                class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out">
              </span>
            </button>
          </div>
        </div>
      </div>



    </div>
  </div>
  